import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-title" }
const _hoisted_2 = { class: "flex w-full justify-end mb-3" }
const _hoisted_3 = { class: "flex justify-between items-center my-1" }
const _hoisted_4 = { class: "p-input-icon-left mr-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_6 = { class: "flex justify-end ml-auto mt-10" }

import {onMounted, ref} from "vue";
import {useRouter} from "vue-router";
import {UserBlackList} from "@/models/blacklisting/UserBlackList";
import {getUsersBlackListed} from "@/_services/blackList/blacklist";
import Button from "primevue/button";

const defaultRowsPerPage = 10;

export default /*#__PURE__*/_defineComponent({
  __name: 'UsersBlacklist',
  setup(__props) {

const router = useRouter();
const isLoading = ref<boolean>(true);
const usersBlackList = Array<UserBlackList>();
const tableData = ref<Array<UserBlackList>>(usersBlackList);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
const currentPage = ref<number>(0);
const criteria = ref<string>("");
const modeSortable = ref<boolean>(false);
const defaultsSort = {
    fieldLabel: "order[listedAt]",
    fieldValue: "desc",
};

onMounted(async () => {
    await populateDatatable(rows.value, page.value, criteria.value, defaultsSort);
});

const populateDatatable = async (
    itemsPerPage: number,
    page: number,
    criteria?:string,
    sort?: { fieldLabel: string; fieldValue: string; }
) => {
    const [isLoadingDt, totalRecordsDt, tableDataDt] = await getUsersBlackListed(itemsPerPage, page, criteria, sort);
    isLoading.value = isLoadingDt;
    totalRecords.value = totalRecordsDt;
    tableData.value = tableDataDt;
};

const onPaginate = async (e) => {
    rows.value = e.rows;
    populateDatatable(e.rows, e.page + 1, criteria.value, defaultsSort);
};

const onFilterDt = () => {
    if (criteria.value != "") {
        populateDatatable(rows.value, page.value, criteria.value);
    }
};

const onClearInputFilter = () => {
    if (criteria.value === "") {
        populateDatatable(rows.value, page.value);
    }
};

const onSort = (e) => {
    if (e.sortField) {
        const sort = {
            fieldLabel: "order[" + e.sortField + "]",
            fieldValue: e.sortOrder === 1 ? "asc" : "desc",
        };
        modeSortable.value = true;
        populateDatatable(rows.value, page.value, criteria.value, sort);
    } else {
        modeSortable.value = false;
        populateDatatable(rows.value, page.value, criteria.value, defaultsSort);
    }
};

const getRoleTag = (roles: string[]) => {
    const roleMappings = {
        'ROLE_ADMIN': { severity: 'warning', value: 'Admin' },
        'ROLE_MANAGER': { severity: 'danger', value: 'Manager' },
        'ROLE_CUSTOMER': { severity: 'info', value: 'Utilisateur' },
        'ROLE_SUPPLIER': { severity: 'contrast', value: 'Fournisseur' },
        'ROLE_DEMO': { severity: 'success', value: 'Demo' }
    };
    const rolesPriority = ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_CUSTOMER', 'ROLE_SUPPLIER', 'ROLE_DEMO'];
    for (const priorityRole of rolesPriority) {
        if (roles.includes(priorityRole)) {
            return roleMappings[priorityRole];
        }
    }

    return { severity: 'Primary', value: 'Inconnu' };
};

const redirectToDetails = (uuid: string) => {
    router.push({name: "UserBlacklistHistorique", params: { uuid: uuid }});
};

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t("catalogue.blacklisting.title")), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Button), {
        label: "Bloquer un utilisateur",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'enabledUsersList' }))),
        icon: "pi pi-ban",
        "aria-label": "Bloquer un utilisateur",
        class: "button-add"
      })
    ]),
    _createVNode(_component_DataTable, {
      lazy: "",
      paginator: "",
      removableSort: "",
      currentPageReportTemplate: "Affichage de {first} à {last} sur {totalRecords} entrées",
      template: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
      value: tableData.value,
      rows: rows.value,
      totalRecords: totalRecords.value,
      rowsPerPageOptions: rowsPerPageOptions,
      currentPage: currentPage.value,
      rowHover: true,
      loading: isLoading.value,
      onSort: _cache[2] || (_cache[2] = ($event: any) => (onSort($event))),
      onPage: onPaginate
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_InputText, {
              type: "text",
              class: "form-control w-64 pl-10 pr-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500",
              onKeyup: _withKeys(onFilterDt, ["enter"]),
              placeholder: "Rechercher...",
              modelValue: criteria.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria).value = $event)),
              onInput: onClearInputFilter
            }, null, 8, ["onKeyup", "modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, "Utilisateurs blacklistés : " + _toDisplayString(totalRecords.value), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_Column, { headerStyle: "width: 3rem" }),
          _createVNode(_component_Column, {
            field: "user.firstname",
            header: "Nom",
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "user.company.name",
            header: "Société",
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.company), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "user.email",
            header: "Email",
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.email), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "listedAt",
            header: "Date du dernier blocage",
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.blockDate), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "user.roles",
            header: "Rôle",
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              (slotProps.data.role.length > 0)
                ? (_openBlock(), _createBlock(_component_Tag, {
                    key: 0,
                    severity: getRoleTag(slotProps.data.role).severity,
                    value: getRoleTag(slotProps.data.role).value,
                    rounded: ""
                  }, null, 8, ["severity", "value"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "active",
            header: "Etat",
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("i", {
                class: _normalizeClass(slotProps.data.active ? 'pi pi-times' : 'pi pi-check'),
                style: _normalizeStyle({ color: slotProps.data.active ? 'red' : 'green' })
              }, null, 6)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "state",
            header: "Statut",
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_Tag, {
                severity: slotProps.data.active ? 'warning' : 'success',
                value: slotProps.data.active ? 'Non traité' : 'Traité',
                rounded: ""
              }, null, 8, ["severity", "value"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "action",
            header: "Action"
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_unref(Button), {
                icon: "pi pi-search",
                size: "small",
                unstyled: "unstyled",
                onClick: ($event: any) => (redirectToDetails(slotProps.data.uuid))
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["value", "rows", "totalRecords", "currentPage", "loading"])
  ]))
}
}

})